// Axios API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// React
import { useEffect, useState } from 'react'

// Mantine
import { Anchor } from '@mantine/core'

// Router
// Dayjs
import dayjs from 'dayjs'

// Status
import { getInvoiceStatus } from '@/lib/retailerStatuses'

// UI
import Badge from '@/components/ui/Badge'
import Box from '@/components/ui/Box'

export default function RetailerSmallInvoiceTable({ retailer_id }) {
    // Axios API
    const { requestGet, loading } = useAxiosApi()

    // Table data
    const [tableData, setTableData] = useState(null)

    // Load table data
    const loadTableData = async () => {
        const { data } = await requestGet(
            `/retailer-invoices?filters[retailer_id][0]=${retailer_id}&per_page=5`
        )

        setTableData(data)
    }

    useEffect(() => {
        if (retailer_id) {
            loadTableData()
        }
    }, [retailer_id])

    const rightSection = (
        <Anchor
            size="sm"
            variant="default"
            href={`/retailer_invoices?retailer_id=${retailer_id}`}
        >
            Toutes les factures ({tableData?.total})
        </Anchor>
    )

    return (
        <Box title="Dernières factures" rightSection={rightSection}>
            {tableData?.data.length > 0 && (
                <div className="flex flex-col divide-y mt-5">
                    <div className="grid grid-cols-[1fr_150px_150px] w-full text-sm py-2">
                        <span>Numéro</span>
                        <span>Montant</span>
                        <span>Statut</span>
                    </div>

                    {tableData.data.map((invoice) => (
                        <div
                            key={invoice.id}
                            className="grid grid-cols-[1fr_150px_150px] w-full text-gray-500 py-2 items-center"
                        >
                            <div className="flex flex-col gap-1 items-start">
                                <Anchor
                                    href={`/retailer_invoices/${invoice.id}`}
                                >
                                    {invoice.number}
                                </Anchor>
                                <span>{dayjs(invoice.date).format('ll')}</span>
                            </div>

                            <span>{invoice.amounts.total_incl_tax} €</span>

                            <Badge
                                color={
                                    getInvoiceStatus(invoice.status).badgeColor
                                }
                            >
                                {getInvoiceStatus(invoice.status).label}
                            </Badge>
                        </div>
                    ))}
                </div>
            )}

            {tableData?.data.length === 0 && (
                <span className="text-sm text-gray-500 my-5 text-center">
                    Aucune facture pour le moment
                </span>
            )}

            <pre className="hidden">
                {JSON.stringify(tableData?.data, null, 2)}
            </pre>
        </Box>
    )
}
